// extracted by mini-css-extract-plugin
export default {"CartItemCard":"CartItemCard_CartItemCard__C31-U"};